import React, { useEffect, useRef, useState } from "react";
import { apiGet } from "../ApiUrls";
import img1 from '../Assets/1721270706-bpfull 711.png'
import moment from "moment";
import ContentLoader from "react-content-loader";
import { io } from "socket.io-client";
import EmojiPicker from "emoji-picker-react";

const socket = io("https://ht-backend.hostessforyou.com");

const HostessChatModel = ({ isOpen, toggleModal, User }) => {
    const chatBodyRef = useRef(null);
    const [chatHistory, setChatHistory] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [messageInput, setMessageInput] = useState("");
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [AllStickers, setAllStickers] = useState([]);
    const [AllGifts, setAllGifts] = useState([]);
    const [showStickerModal, setShowStickerModal] = useState(false);
    const [showGiftModal, setShowGiftModal] = useState(false);

    const handleStickerSelect = (sticker) => {
        setShowStickerModal(false);
        sendMessage("sticker", "", sticker.Image);
    };

    const handleGiftSelect = (gift) => {
        setShowGiftModal(false);
        sendMessage("gift", "", "", gift.Image);
    };


    const GetAllStickers = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(`api/admin/GetAllSticker`);
            setAllStickers(response?.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error("Error fetching stickers:", error);
        }
    };

    const GetAllGifts = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(`api/admin/GetAllGift`);
            setAllGifts(response?.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error("Error fetching gifts:", error);
        }
    };


    const onEmojiClick = (emojiObject) => {
        setMessageInput((prevInput) => prevInput + emojiObject.emoji);
    };

    const GetAllChatHistorywithUser = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(`api/hostess/GetHostessChatHistory/${User?.id}`);
            setChatHistory(response?.data || []);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error("Error fetching chat history:", error);
        }
    };


    const sendMessage = (type = "text", content = messageInput.trim(), stickerUrl = "", giftDetails = "") => {
        if (!content && !stickerUrl && !giftDetails) return;
        const Hostessid = localStorage.getItem("userid");

        const messageData = {
            senderId: Hostessid,
            senderModel: "Hostess",
            receiverId: User?.id,
            receiverModel: "User",
            type,
            message: content,
            stickerUrl,
            giftDetails,
            isSent: true
        };

        socket.emit("sendMessage", messageData);
        setChatHistory((prev) => [...prev, { ...messageData, createdAt: new Date() }]);
        if (type === "text") {
            setMessageInput("");
        }
    };

    // const handleIncomingMessage = (message) => {
    //     setChatHistory((prev) => [...prev, message]);
    // };

    const handleIncomingMessage = (message) => {
        setChatHistory((prev) => [...prev, message]);

        const Userid = localStorage.getItem("userid");
        if (message?.receiver === Userid && !message?.isRead) {
            socket.emit("markAsRead", { messageId: message._id, userId: Userid });
        }
    };

    useEffect(() => {
        socket.on("messageRead", ({ messageId }) => {
            setChatHistory((prev) =>
                prev.map((msg) =>
                    msg.id === messageId ? { ...msg, isRead: true } : msg
                )
            );
        });

        return () => {
            socket.off("messageRead");
        };
    }, []);


    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            sendMessage();
        }
    };

    useEffect(() => {
        const Hostessid = localStorage.getItem("userid");
        if (User && isOpen) {
            GetAllChatHistorywithUser();
            GetAllGifts();
            GetAllStickers();

            socket.emit("joinRoom", { userId: Hostessid });

            socket.on("receiveMessage", handleIncomingMessage);
        }

        return () => {
            socket.off("receiveMessage", handleIncomingMessage);
        };
    }, [User, isOpen]);

    useEffect(() => {
        if (chatBodyRef.current) {
            chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
        }
    }, [chatHistory]);


    const renderChatMessages = () =>
        chatHistory?.map((message) => {

            const Userid = localStorage.getItem("userid");
            const isSentByUser =
                message?.sender?.id === Userid ||
                message?.sender === Userid ||
                message?.senderId === Userid;

            return (
                <div
                    key={message?.id}
                    className={`message ${isSentByUser ? "sent" : "received"}`}
                >
                    <div className="message-content">
                        {message.type === "text" ? (
                            <span className="message-text">{message?.message}</span>
                        ) : message.type === "sticker" ? (
                            <img src={message?.stickerUrl} alt="Sticker" className="stickerView" />
                        ) : (
                            <img src={message?.giftDetails} alt="Gift" className="giftView" />
                        )}
                        <span className="timestamp">
                            {moment(message?.createdAt)?.format("hh:mm A")}
                        </span>
                        <div className="message-status">
                            {message?.isRead ? (
                                <span className="read">✔✔</span>
                            ) : message?.isSent ? (
                                <span className="sent">✔</span>
                            ) : (
                                <span className="pending">⏳</span>
                            )}
                        </div>
                    </div>
                </div>
            );
        });


    return (
        <>
            {isOpen && (
                <div className="chat-modal">
                    <div className="chat-header">
                        <div className="user-info">
                            <img
                                src={User?.profilePicture || img1}
                                alt="User"
                                className="user-avatar"
                            />
                            <div className="NameStatus">
                                <span>{User?.name}</span>
                                <span>Available Online</span>
                            </div>
                        </div>
                        <button className="close-btn" onClick={toggleModal}>
                            ✖
                        </button>
                    </div>
                    <div className="chat-body" ref={chatBodyRef}>
                        {isUploading ? (
                            <ContentLoader viewBox="0 0 400 160" height={200} width={350}>
                                <rect x="0" y="12" rx="5" ry="5" width="220" height="10" />
                                <rect x="0" y="29" rx="5" ry="5" width="220" height="10" />
                                <rect x="179" y="76" rx="5" ry="5" width="220" height="10" />
                                <rect x="179" y="58" rx="5" ry="5" width="220" height="10" />
                                <rect x="0" y="104" rx="5" ry="5" width="220" height="10" />
                                <rect x="0" y="122" rx="5" ry="5" width="220" height="10" />
                            </ContentLoader>
                        ) : (
                            renderChatMessages()
                        )}
                    </div>
                    <div className="chat-footer">
                        {showStickerModal && (
                            <div className="modal">
                                <div className="modal-content">
                                    <button className="close" onClick={() => setShowStickerModal(false)}>X</button>
                                    <h3>Select Sticker</h3>
                                    <div className="stickers">
                                        {AllStickers.map((sticker) => (
                                            <img
                                                key={sticker._id}
                                                src={sticker.Image}
                                                alt="Sticker"
                                                onClick={() => handleStickerSelect(sticker)}
                                                className="sticker"
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        {showGiftModal && (
                            <div className="modal">
                                <div className="modal-content">
                                    <button className="close" onClick={() => setShowGiftModal(false)}>X</button>
                                    <h3>Select Gift</h3>
                                    <div className="gifts">
                                        {AllGifts.map((gift) => (
                                            <img
                                                key={gift._id}
                                                src={gift.Image}
                                                alt="Gift"
                                                onClick={() => handleGiftSelect(gift)}
                                                className="gift"
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div>
                            <button className="sticker-btn" onClick={() => setShowStickerModal(true)}>
                                Sticker
                            </button>
                            <button className="gift-btn" onClick={() => setShowGiftModal(true)}>
                                Gift
                            </button>
                            <button className="emoji-btn" onClick={() => setShowEmojiPicker((prev) => !prev)}>
                                😊
                            </button>
                            {showEmojiPicker && (
                                <div className="emoji-picker">
                                    <EmojiPicker onEmojiClick={onEmojiClick} />
                                </div>
                            )}
                        </div>

                        <div>
                            <input
                                type="text"
                                placeholder="Type a message here..."
                                className="message-input"
                                value={messageInput}
                                onChange={(e) => setMessageInput(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                            />
                            <button className="send-btn" onClick={() => sendMessage()}>
                                Send
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HostessChatModel;
